var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('Dashboard',{attrs:{"type":"push"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"path"},[_c('small',[_vm._v("PUSH NOTIFICATION")]),_c('span',[_vm._v(">")]),_c('small',[_vm._v("DASHBOARD")]),_c('h4',[_vm._v("Dashboard Push Notification")])])
}]

export { render, staticRenderFns }